globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Help = appCustomerSpace.Controllers.Help || {};

appCustomerSpace.Controllers.Help.MainController = (function(superClass) {

    utils.extend(MainController, superClass);

    function MainController() {
        return MainController.__super__.constructor.apply(this, arguments);
    }

    $.extend(MainController.prototype, {
        init: function(){
            var $intercomLauncher = $('.intercom-launcher');

            if($intercomLauncher) {
              $('.open-intercom-btn').on('click', function(e){
                e.preventDefault();
                $intercomLauncher.click();
              });
            };

            return MainController.__super__.init.apply(this, arguments);
        }
    });

    return MainController;

})(appCustomerSpace.Controllers.MainController);
